(function () {
  'use strict';

  angular.module('app').component('hotelDetail', hotelDetail());

  function hotelDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        activeTab: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
        userLanguageCode: '<',
      },
      controller: HotelDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotels/hotel-detail/hotel-detail.component.html',
    };
  }

  HotelDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$location',
    '$filter',
    'HotelService',
    'HotelContentService',
    'MeasurementUnitService',
    'SessionService',
    'ProductCategoryService',
    'TaxService',
    'ProductService',

    // Angular downgraded service
    'categoryService',
    'categoryModalService',
    'facilityService',
    'facilityModalService',
    'zoneService',
    'zoneModalService',
    'locationService',
    'locationModalService',
    'utilService',
    'companyService',
  ];

  function HotelDetailComponent(
    config,
    UtilService,
    $location,
    $filter,
    HotelService,
    HotelContentService,
    MeasurementUnitService,
    SessionService,
    ProductCategoryService,
    TaxService,
    ProductService,

    // Angular downgraded service
    categoryService,
    categoryModalService,
    facilityService,
    facilityModalService,
    zoneService,
    zoneModalService,
    locationService,
    locationModalService,
    utilService,
    companyService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.starOptions = config.STAR_OPTIONS;
    vm.hourDisplay = config.HOUR_DISPLAY;
    vm.showMeridian = true;

    vm.checkedCategory = {};
    vm.checkedFacility = {};

    vm.productSearchId = null;

    // Methods
    vm.selectProductCategory = selectProductCategory;
    vm.openProductCategoriesModal = openProductCategoriesModal;

    vm.openLocationsModal = openLocationsModal;
    vm.selectLocation = selectLocation;
    vm.openZonesModal = openZonesModal;
    vm.openCategoriesModal = openCategoriesModal;
    vm.openFacilitiesModal = openFacilitiesModal;

    vm.openHotelContentsModal = openHotelContentsModal;

    vm.onHotelRoomDeleted = onHotelRoomDeleted;

    vm.editHotel = editHotel;
    vm.cancelEdit = cancelEdit;
    vm.saveHotel = saveHotel;
    vm.cancel = cancel;

    vm.selectAssociatedProviders = selectAssociatedProviders;
    vm.onAssociatedProviderSaved = onAssociatedProviderSaved;
    vm.onAssociatedProviderDeleted = onAssociatedProviderDeleted;
    vm.onSelectedTab = onSelectedTab;
    vm.selectAccounting = selectAccounting;

    vm.selectCostsAndPrices = selectCostsAndPrices;
    vm.onCostsAndPricesSaved = onCostsAndPricesSaved;

    vm.selectAssociatedTaxes = selectAssociatedTaxes;
    vm.onAssociatedTaxesSaved = onAssociatedTaxesSaved;
    vm.onAssociatedTaxesCanceled = onAssociatedTaxesCanceled;

    vm.$onInit = function () {
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      if (vm.item.id) {
        // Edit
        vm.active = vm.activeTab ? parseInt(vm.activeTab) : 0;

        if (vm.item.check_out.split(' ').length > 1) {
          vm.item.check_out = vm.item.check_out.split(' ')[0];
          vm.item.check_in = vm.item.check_in.split(' ')[0];
        }

        if (!vm.item.check_in || !vm.item.check_out) {
          vm.check_in = vm.UtilService.setDurationTime();
          vm.check_out = vm.UtilService.setDurationTime();

          formatHourTime();
        }

        setItemOptions(vm.item, vm.mode);
        getServerData(vm.item);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          has_allotments: false,
          company_id: SessionService.getSelectedAccountCompany().id,
        };

        vm.check_in = vm.UtilService.setDurationTime();
        vm.check_out = vm.UtilService.setDurationTime();

        // Initializers
        getLocations();
        getProductCategories('');
      }

      // Initializers
      getCompany();

      getHotels();

      getCategories();
      getFacilities();
    };

    vm.openSearchCabys = function (item) {
      const succesCallBack = (itemObj) => {
        vm.item.cabys_code = itemObj.codigo;
        vm.item.cabys_description = itemObj.descripcion;
        vm.item.cabys_tax = itemObj.impuesto;
      };

      ProductService.openSearchCabys(item, succesCallBack);
    };

    vm.searchCabys = function () {
      if (!vm.item.cabys_code || vm.item.cabys_code.length < 13) return;

      let searchBy = 'codigo=' + vm.item.cabys_code.toLowerCase();

      vm.clearCabys();

      vm.invalidCabys = false;

      vm.searchingCabys = true;
      ProductService.searchCabys(searchBy).then(function (data) {
        if (data[0] && data[0].codigo) {
          vm.item.cabys_code = data[0].codigo;
          vm.item.cabys_description = data[0].descripcion;
          vm.item.cabys_tax = data[0].impuesto;

          vm.invalidCabys = false;
        } else {
          vm.invalidCabys = true;
        }

        vm.searchingCabys = false;
      });
    };

    vm.clearCabys = function () {
      vm.item.cabys_description = '';
      vm.item.cabys_tax = '';
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editMode = true;

        editHotel();
      }

      vm.productIsExempt = item.is_exempt || false;

      vm.productCategorySelected = item.product_category;

      setCheckedCategories(item.category_ids);
      setCheckedFacilities(item.facility_ids);

      vm.customTaxConfiguration = item.custom_tax_configuration;

      vm.itemName = item.name;

      vm.originalItem = angular.copy(item); // store server data

      vm.flashMessage = vm.UtilService._displayFlashMessage();
    }

    function getServerData(item) {
      if (item.location_id) {
        getZonesByLocation(item.location_id);
      }

      // To reload code number consecutive
      getProductCategories('');
    }

    function editHotel() {
      vm.editMode = true;
      vm.viewMode = false;

      if (vm.UtilService.setDurationTime(vm.item.check_in) === 'Invalid Date') {
        vm.check_in = vm.UtilService.setDurationTime();
        vm.check_out = vm.UtilService.setDurationTime();
      } else {
        vm.check_in = vm.UtilService.setDurationTime(vm.item.check_in);
        vm.check_out = vm.UtilService.setDurationTime(vm.item.check_out);
      }

      // Initializers
      getLocations();
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function getCompany() {
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: vm.userLanguageCode,
        })
        .subscribe((response) => {
          // defaultLanguage
          if (response.country.country_setting) {
            vm.taxTypes = response.country.country_setting.tax_types;
            vm.taxRateCodes = response.country.country_setting.tax_rate_codes;
          }

          vm.measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
            response.measurement_units,
            'hotel'
          );

          if (!vm.createMode) {
            vm.measurementUnit = vm.measurementUnits.find(
              (item) => item.id === vm.item.measurement_unit_id
            );
          }
        });
    }

    // ----- PRODUCT CATEGORIES ----- //

    function getProductCategories(option) {
      var params = {
        get: 'active',
        by_product_type: 'hotel',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingProductCategories = true;
      ProductCategoryService.getProductCategories(params).then(function (data) {
        vm.productCategories = data.items;
        vm.loadingProductCategories = false;

        if (option === 'update') {
          let productCategory = vm.productCategories.find(
            (item) => item.id === vm.productCategorySelected.id
          );

          vm.productCategorySelected = null;
          selectProductCategory(productCategory);
        }
      });
    }

    function selectProductCategory(productCategory) {
      if (vm.productCategorySelected && vm.productCategorySelected.id === productCategory.id) {
        // Same product category is selected
        return;
      }

      vm.productCategorySelected = productCategory;

      vm.item.code_number = '';

      // Edit mode
      if (vm.editMode) {
        // Same product category as the item
        if (vm.originalItem.product_category_id === productCategory.id) {
          vm.item.code = vm.originalItem.code;
          vm.item.code_number = vm.originalItem.code_number;
        } else {
          if (productCategory.coding_type === 'automatic') {
            vm.item.code =
              productCategory.coding_prefix + productCategory.nextProductCodeNumberToAssign;
            vm.item.code_number = productCategory.nextProductCodeNumberToAssign;
          }
        }
      }
    }

    function openProductCategoriesModal() {
      var successCallback = function () {
        getProductCategories('update');
      };

      ProductCategoryService.openProductCategoriesModal(successCallback);
    }

    // ----- HOTELS ----- //

    function getHotels() {
      var params = {
        get: 'all',
        // hotelId: vm.item.id,
        skip_check_role: true,
      };

      vm.loadingHotels = true;

      HotelService.getHotels(params).then(function (data) {
        // vm.hotels = data.items;

        vm.hotels = [];

        data.items.forEach(function (item, index) {
          item.prev = data.items[index - 1];
          item.next = data.items[index + 1];

          vm.hotels.push(item);
        });

        if (!vm.createMode) {
          vm.productSelected = angular.copy(vm.item); // To keep diferent scope as we modify .prev / .next

          const productFound = vm.hotels.find((product) => product.id === vm.item.id);

          vm.productSelected.prev = productFound.prev;
          vm.productSelected.next = productFound.next;

          vm.productSearchId = vm.item.id;
        }

        // Related products
        vm.relatedHotels = vm.hotels.filter((product) => {
          return product.id !== vm.item.id;
        });

        vm.loadingHotels = false;
      });
    }

    vm.selectProduct = function (product) {
      if (vm.productSelected && vm.productSelected.id === product.id) {
        return;
      }

      $location.path(`/hotels/${product.id}`);
    };

    vm.goToOtherProduct = function (otherProductId) {
      let product = vm.UtilService.findItemInArray(vm.hotels, 'id', otherProductId);

      vm.selectProduct(product);
    };

    function openHotelContentsModal() {
      HotelContentService.openHotelContentsModal(vm.item);
    }

    // ----- LOCATIONS ----- //

    function getLocations() {
      if (vm.locations) {
        return;
      }

      var params = {
        get: 'active',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      vm.loadingLocations = true;
      locationService.getLocations(params).subscribe((response) => {
        vm.locations = locationService.groupLocations(response); // , '', 'locations'
        vm.loadingLocations = false;
      });
    }

    function openLocationsModal() {
      var successCallback = function () {
        vm.locations = null;
        getLocations();
      };

      locationModalService.openLocationsModal(successCallback);
    }

    function selectLocation(locationId) {
      vm.item.zone_id = null;

      getZonesByLocation(locationId);
    }

    function getZonesByLocation(locationId) {
      var params = {
        get: 'by_location',
        location_id: locationId,
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      zoneService.getZones(params).subscribe((response) => {
        vm.zones = response;
      });
    }

    function openZonesModal() {
      var successCallback = function () {
        getZonesByLocation(vm.item.location_id);
      };

      zoneModalService.openZonesModal(successCallback);
    }

    // ----- CATEGORIES ----- //

    function getCategories() {
      var params = {
        get: 'hotel',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      categoryService.getCategories(params).subscribe((response) => {
        vm.categories = response;
      });
    }

    function openCategoriesModal() {
      const successCallback = () => {
        getCategories();
      };

      categoryModalService.openCategoriesModal(successCallback);
    }

    function setCheckedCategories(category_ids) {
      category_ids.forEach((key) => {
        vm.checkedCategory[key] = true;
      });
    }

    // ----- FACILITIES ----- //

    function getFacilities() {
      var params = {
        get: 'hotel',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      facilityService.getFacilities(params).subscribe((response) => {
        vm.facilities = response;
      });
    }

    function openFacilitiesModal() {
      const successCallback = () => {
        getFacilities();
      };

      facilityModalService.openFacilitiesModal(successCallback);
    }

    function setCheckedFacilities(facility_ids) {
      facility_ids.forEach((key) => {
        vm.checkedFacility[key] = true;
      });
    }

    function onHotelRoomDeleted(hotel) {
      vm.item.hotel_rooms = hotel.hotel_rooms;
      vm.item.associated_providers = hotel.associated_providers;
      vm.showAssociatedProviders = false;
    }

    function formatHourTime() {
      vm.item.check_in = $filter('date')(vm.check_in, 'HH:mm');
      vm.item.check_out = $filter('date')(vm.check_out, 'HH:mm');
    }

    // Create/Update
    function saveHotel(isFormValid) {
      vm.formErrors = false;

      if (
        !isFormValid ||
        vm.productCategories.length === 0 ||
        vm.locations === 0
        // || !vm.item.zone_id
        // || (vm.atvCrEnabled && !vm.item.cabys_description)
      ) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      vm.item.category_ids = utilService.parseItemIds(vm.checkedCategory);
      vm.item.facility_ids = utilService.parseItemIds(vm.checkedFacility);

      // var geo_lat = <HTMLInputElement>document.getElementById('geo_lat');
      // var geo_lng = <HTMLInputElement>document.getElementById('geo_lng');
      // var geo_zoom = <HTMLInputElement>document.getElementById('geo_zoom');

      // vm.item.geo_lat = geo_lat.value;
      // vm.item.geo_lng = geo_lng.value;
      // vm.item.geo_zoom = geo_zoom.value;

      vm.item.geo_lat = document.getElementById('geo_lat').value;
      vm.item.geo_lng = document.getElementById('geo_lng').value;
      vm.item.geo_zoom = document.getElementById('geo_zoom').value;

      formatHourTime();

      vm.sendingForm = true;
      HotelService.saveHotel(vm.item).then(function (data) {
        let status = data.status;
        let response = data.response;

        if (status) {
          // Success
          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: response });
          } else {
            vm.item = response;
            setItemOptions(response);

            vm.measurementUnit = vm.measurementUnits.find(
              (item) => item.id === response.measurement_unit_id
            );

            getServerData(response);

            vm.flashMessage = vm.UtilService._clearFlashMessage();
            vm.UtilService.scrollToTop();
          }
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;

          vm.UtilService.scrollToTop();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onCanceledItem({ item: vm.item });
    }

    // ----- ASSOCIATED PROVIDERS ----- //
    function selectAssociatedProviders() {
      vm.showAssociatedProviders = true;
    }

    function onAssociatedProviderSaved(product, items) {
      vm.item.default_provider_id = product.default_provider_id;

      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onAssociatedProviderDeleted(items) {
      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onSelectedTab(tab) {
      vm.active = tab;
    }

    // ----- ACCOUNTING -----
    function selectAccounting() {
      vm.showAccounting = true;
    }

    // ----- COSTS AND PRICES -----

    function selectCostsAndPrices() {
      vm.showCostsAndPrices = false;

      setTimeout(() => {
        vm.showCostsAndPrices = true;
      }, 100); // hack

      // vm.showCostsAndPrices = true;
    }

    function onCostsAndPricesSaved(associated_providers) {
      vm.item.associated_providers = associated_providers;
      vm.originalItem.associated_providers = associated_providers;
    }

    // ----- ASSOCIATED TAXES -----

    function selectAssociatedTaxes(reload) {
      if (vm.taxes && !reload) {
        return;
      }

      let productCategoryAssociatedTaxes = {
        purchases: [],
        sales: [],
      };

      if (vm.item.product_category.associated_taxes) {
        vm.item.product_category.associated_taxes.map((associated_tax) => {
          if (associated_tax.scope_type === 'purchases') {
            productCategoryAssociatedTaxes.purchases.push(associated_tax);
          } else {
            productCategoryAssociatedTaxes.sales.push(associated_tax);
          }
        });
      }

      vm.taxes = TaxService.setAssociatedTaxes(
        productCategoryAssociatedTaxes,
        vm.item.associated_taxes,
        vm.taxTypes
      );
      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    function onAssociatedTaxesSaved(product) {
      if (!vm.customTaxConfiguration) {
        delete product.exonerations;
      }

      vm.item = product;
      vm.originalItem = angular.copy(vm.item);
      // vm.taxesOriginal = angular.copy(vm.taxes);

      selectAssociatedTaxes(true);
    }

    function onAssociatedTaxesCanceled() {
      vm.customTaxConfiguration = vm.originalItem.custom_tax_configuration;

      vm.taxes = vm.taxesOriginal;
      vm.taxesOriginal = angular.copy(vm.taxes);
    }
  }
})();
